import { FC } from "react";
import { Icon } from "@/components";
import { TimePicker } from "@/ui";
import { WorkingHourFormProps } from "context/schedule/types";
import styles from "./WorkingHour.module.scss";

const WorkingHourForm: FC<WorkingHourFormProps> = ({
    start,
    end,
    onChange,
    toggleCustomizeTimeSlot,
    customizeTimeSlot,
    errors,
}) => {
    const handleStartChange = (value: string) => {
        onChange("start", value);
        if (customizeTimeSlot && value && end) {
            toggleCustomizeTimeSlot(value, end);
        }
    };

    const handleEndChange = (value: string) => {
        onChange("end", value);
        if (customizeTimeSlot && start && value) {
            toggleCustomizeTimeSlot(start, value);
        }
    };

    const handlePickerClose = (open: boolean) => {
        if (!open && customizeTimeSlot) {
            toggleCustomizeTimeSlot();
        }
    };

    return (
        <div className={styles.hoursBlock}>
            <p className={styles.sectionLabel}>Working Hours</p>
            <div className={styles.hoursRow}>
                <div className={styles.hoursField}>
                    <TimePicker
                        error={errors?.start}
                        fullWidth
                        label="Start time"
                        name="start"
                        onChange={handleStartChange}
                        onOpenChange={handlePickerClose}
                        value={start ?? ""}
                    />
                </div>
                <span aria-hidden className={styles.hoursArrow}>
                    <Icon icon="arrow_next" />
                </span>
                <div className={styles.hoursField}>
                    <TimePicker
                        error={errors?.end}
                        fullWidth
                        label="End time"
                        name="end"
                        onChange={handleEndChange}
                        onOpenChange={handlePickerClose}
                        value={end ?? ""}
                    />
                </div>
            </div>
        </div>
    );
};

export default WorkingHourForm;
